var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 124,
    viewBox: "0 0 112 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5664 91.6914H83.5634H10.4523C8.24899 91.6914 6.42349 90.9354 4.84103 89.353C3.25866 87.7706 2.50515 85.9478 2.50782 83.75V83.747V10.6359C2.50782 8.43258 3.26379 6.60709 4.84625 5.02463C6.42863 3.44226 8.2514 2.68875 10.4492 2.69142H10.4523H72.0834L91.5078 22.1158V83.747C91.5078 85.9502 90.7518 87.7757 89.1694 89.3582C87.587 90.9406 85.7642 91.6941 83.5664 91.6914ZM83.5634 94.1914H10.4523C7.58004 94.1914 5.12038 93.1678 3.07326 91.1207C1.02615 89.0736 0.00433988 86.6157 0.00782137 83.747V10.6359C0.00782137 7.76364 1.03138 5.30397 3.07849 3.25686C5.1256 1.20975 7.58352 0.187934 10.4523 0.191415L83.5634 94.1914ZM13.1745 36.747V39.247H15.6745H62.6745H65.1745V36.747V15.8581V13.3581H62.6745H15.6745H13.1745V15.8581V36.747ZM47.0078 81.0247C52.0151 81.0247 56.3523 79.2435 59.8728 75.7231C63.3933 72.2026 65.1745 67.8654 65.1745 62.8581C65.1745 57.8507 63.3933 53.5135 59.8728 49.9931C56.3523 46.4726 52.0151 44.6914 47.0078 44.6914C42.0005 44.6914 37.6633 46.4726 34.1428 49.9931C30.6224 53.5135 28.8412 57.8507 28.8412 62.8581C28.8412 67.8654 30.6224 72.2026 34.1428 75.7231C37.6633 79.2435 42.0005 81.0247 47.0078 81.0247Z",
    fill: "#D5D5D5",
    stroke: "#BFBFBF",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.992 85.6523C107.992 104.516 92.6999 119.809 73.8359 119.809C54.972 119.809 39.6797 104.516 39.6797 85.6523C39.6797 66.7884 54.972 51.4961 73.8359 51.4961C92.6999 51.4961 107.992 66.7884 107.992 85.6523Z",
    fill: "#48BD69",
    stroke: "#D9F5E1",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9474 74.6256L67.7956 96.6714L57.7266 86.6506",
    fill: "#48BD69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9474 74.6256L67.7956 96.6714L57.7266 86.6506",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSaved);
export default __webpack_public_path__ + "static/media/videoSaved.0937f2356d986438aff92f018f54c550.svg";
export { ForwardRef as ReactComponent };